import { formatDate, getLocaleFirstDayOfWeek } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IDataPanelViewModel, IStatViewModel, IViewData } from 'src/app/share/entities/view-model';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';

@Component({
  selector: 'app-user-activity-monitor',
  templateUrl: './user-activity-monitor.component.html',
  styleUrls: ['./user-activity-monitor.component.scss']
})
export class UserActivityMonitorComponent implements OnInit {

  constructor(private commonService: CommonService, private authService: AuthService, private http: HttpClient) { }

  vm$: Observable<any>
  tableMaxHeight: number = 300;

  ngOnInit(): void {
    this.vm$ = this.userActivityMonitor$();

    this.vm$ = timer(0, 300000).pipe(
      switchMap(() => this.userActivityMonitor$())
    );
  }

  /**
   * 
   */
   refreshPage() {
    this.vm$ = this.userActivityMonitor$();
    this.authService.userInRole;
  }

  /**
   * 
   * 
   */
   private userActivityMonitor$(): Observable<IPageDataViewModel> {
    return this.commonService.getData('PageCommand', 'user.activity.monitor', 'page-load', undefined, '/api/SantaCruz', true).pipe(
      map((v: IViewModelUserActivity) => {
        //if (v.workingText)
        //  return { ...v };

        const ret = { ...v, actionsAllowed: true };
        if (ret.data) {

          ret.statPanelVm = ret.data.statPanel ? {
            data: ret.data.statPanel
          } : null;

          ret.reservationPanelVm = ret.data.reservationPanel && !ret.data.reservationPanel.unauthorized ? {
            data: ret.data.reservationPanel,
            rows: ret.data.reservationPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            rowsFiltered: ret.data.reservationPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            styleTypes: [],
            styleTypesFiltered: ret.data.reservationPanel.styleTypes,
            lastUpdateDateTime: formatDate(ret.data.reservationPanel.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US')
          } : null;

          ret.dispatchersPanelVm = ret.data.dispatchersPanel && !ret.data.dispatchersPanel.unauthorized ? {
            data: ret.data.dispatchersPanel,
            rows: ret.data.dispatchersPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            rowsFiltered: ret.data.dispatchersPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            styleTypes: [],
            styleTypesFiltered: ret.data.dispatchersPanel.styleTypes,
            lastUpdateDateTime: formatDate(ret.data.dispatchersPanel.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US')
          } : null;

          ret.accountingPanelVm = ret.data.accountingPanel && !ret.data.accountingPanel.unauthorized ? {
            data: ret.data.accountingPanel,
            rows: ret.data.accountingPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            rowsFiltered: ret.data.accountingPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            styleTypes: [],
            styleTypesFiltered: ret.data.accountingPanel.styleTypes,
            lastUpdateDateTime: formatDate(ret.data.accountingPanel.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US')
          } : null;

          ret.qcPanelVm = ret.data.qcPanel && !ret.data.qcPanel.unauthorized ? {
            data: ret.data.qcPanel,
            rows: ret.data.qcPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            rowsFiltered: ret.data.qcPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            styleTypes: [],
            styleTypesFiltered: ret.data.qcPanel.styleTypes,
            lastUpdateDateTime: formatDate(ret.data.qcPanel.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US')
          } : null;

          ret.eventPanelVm = ret.data.eventPanel && !ret.data.eventPanel.unauthorized ? {
            data: ret.data.eventPanel,
            rows: ret.data.eventPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            rowsFiltered: ret.data.eventPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            styleTypes: [],
            styleTypesFiltered: ret.data.eventPanel.styleTypes,
            lastUpdateDateTime: formatDate(ret.data.eventPanel.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US')
          } : null;

          ret.salesPanelVm = ret.data.salesPanel && !ret.data.salesPanel.unauthorized ? {
            data: ret.data.salesPanel,
            rows: ret.data.salesPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            rowsFiltered: ret.data.salesPanel.rows.map(r => ({ code: r[0], actionTitle: "", fields: r })),
            styleTypes: [],
            styleTypesFiltered: ret.data.salesPanel.styleTypes,
            lastUpdateDateTime: formatDate(ret.data.salesPanel.lastUpdateDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US')
          } : null;
        }

        return ret;
      })
    );
  }

}

/**
 * 
 */
 interface IViewModelUserActivity extends IPageDataViewModel {
  data?: { statPanel: any, reservationPanel: IViewData, dispatchersPanel: IViewData, accountingPanel: IViewData, qcPanel: IViewData, eventPanel: IViewData, salesPanel: IViewData }

  statPanelVm: IStatViewModel;
  
  reservationPanelVm: IDataPanelViewModel;
  dispatchersPanelVm: IDataPanelViewModel;
  accountingPanelVm: IDataPanelViewModel;
  qcPanelVm: IDataPanelViewModel;
  eventPanelVm: IDataPanelViewModel;
  salesPanelVm: IDataPanelViewModel;

  actionsAllowed?: boolean;
  lastDateTimeUpdated: string;
  
}
